import { CLIENT_STYLINGS } from './constants'

export const getBorderRadius = (props, scale = 'md') => {
  const baseRadius =
    CLIENT_STYLINGS[props.theme.organizationSlug].BORDERS_RADIUS * 16
  switch (scale) {
    case 'sm':
      return `${Math.max(0, baseRadius - 4)}px`
    case 'md':
      return `${Math.max(0, baseRadius - 2)}px`
    case 'lg':
      return `${Math.max(0, baseRadius)}px`
    case 'xl':
      return `${Math.max(0, baseRadius + 4)}px`
    case '2xl':
      return `${Math.max(0, baseRadius + 8)}px`
    default:
      return `${Math.max(0, baseRadius)}px`
  }
}

export const getShadow = (props, scale = 'md') => {
  switch (scale) {
    case '2xs':
      return '0 1px rgb(0 0 0 / 0.05)'
    case 'xs':
      return '0 1px 2px 0 rgb(0 0 0 / 0.05)'
    case 'sm':
      return '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)'
    case 'md':
      return '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
    case 'lg':
      return '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
    case 'xl':
      return '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'
    case '2xl':
      return '0 25px 50px -12px rgb(0 0 0 / 0.25)'
    case 'none':
      return 'none'
    default:
      return '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
  }
}


